import { SignalSocket } from "./SignalSocket";
import { ObservableSocket } from "./ObservableSocket";
// export * from "./SignalSocket";
// export * from "./ObservableSocket";

export var signals = {
    SignalSocket,
    ObservableSocket,
};